/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PaymentIndexRouteImport } from './routes/payment/index'
import { Route as PaymentTokenRouteImport } from './routes/payment/$token'
import { Route as AuthTwoFactorRouteImport } from './routes/_auth/two-factor'
import { Route as AuthTermsRouteImport } from './routes/_auth/terms'
import { Route as AuthResetRouteImport } from './routes/_auth/reset'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotRouteImport } from './routes/_auth/forgot'
import { Route as AuthExpiredLinkRouteImport } from './routes/_auth/expired-link'
import { Route as AppSupportRouteImport } from './routes/_app/support'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppBrokersRouteImport } from './routes/_app/brokers'
import { Route as AppAdvisoriesRouteImport } from './routes/_app/advisories'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index'
import { Route as AppQuotesIndexRouteImport } from './routes/_app/quotes/index'
import { Route as AppProposalsIndexRouteImport } from './routes/_app/proposals/index'
import { Route as AppProposalAnalysesIndexRouteImport } from './routes/_app/proposal-analyses/index'
import { Route as AppPoliciesIndexRouteImport } from './routes/_app/policies/index'
import { Route as AppNotificationsIndexRouteImport } from './routes/_app/notifications/index'
import { Route as AppIntegrationsIndexRouteImport } from './routes/_app/integrations/index'
import { Route as AppInspectionsIndexRouteImport } from './routes/_app/inspections/index'
import { Route as AppFinancialIndexRouteImport } from './routes/_app/financial/index'
import { Route as AppBrokersIndexRouteImport } from './routes/_app/brokers/index'
import { Route as AppAnalysesIndexRouteImport } from './routes/_app/analyses/index'
import { Route as AppAdvisoriesIndexRouteImport } from './routes/_app/advisories/index'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppSettingsReportsRouteImport } from './routes/_app/settings/reports'
import { Route as AppSettingsAuditRouteImport } from './routes/_app/settings/audit'
import { Route as AppSettingsProductsIndexRouteImport } from './routes/_app/settings/products/index'
import { Route as AppQuotesRdEquipamentosIndexRouteImport } from './routes/_app/quotes/rd-equipamentos/index'
import { Route as AppQuotesProductsIndexRouteImport } from './routes/_app/quotes/products/index'
import { Route as AppQuotesPolicyIdIndexRouteImport } from './routes/_app/quotes/$policyId/index'
import { Route as AppProposalsIdIndexRouteImport } from './routes/_app/proposals/$id/index'
import { Route as AppProposalAnalysesProposalIdIndexRouteImport } from './routes/_app/proposal-analyses/$proposalId/index'
import { Route as AppPoliciesPolicyIdIndexRouteImport } from './routes/_app/policies/$policyId/index'
import { Route as AppIntegrationsPolicyIdIndexRouteImport } from './routes/_app/integrations/$policyId/index'
import { Route as AppBrokersIdIndexRouteImport } from './routes/_app/brokers/$id/index'
import { Route as AppAnalysesPolicyIdIndexRouteImport } from './routes/_app/analyses/$policyId/index'
import { Route as AppAdvisoriesIdIndexRouteImport } from './routes/_app/advisories/$id/index'
import { Route as AppQuotesProductsNewRouteImport } from './routes/_app/quotes/products/new'
import { Route as AppQuotesPolicyIdEditRouteImport } from './routes/_app/quotes/$policyId/edit'
import { Route as AppSettingsProductsPaymentMethodsIndexRouteImport } from './routes/_app/settings/products/payment-methods/index'
import { Route as AppQuotesProductsNewIndexRouteImport } from './routes/_app/quotes/products/new/index'
import { Route as AppProposalsIdPmeIndexRouteImport } from './routes/_app/proposals/$id/pme/index'
import { Route as AppProposalsIdEditIndexRouteImport } from './routes/_app/proposals/$id/edit/index'
import { Route as AppProposalsIdCapitalGlobalIndexRouteImport } from './routes/_app/proposals/$id/capital-global/index'
import { Route as AppProposalAnalysesProposalIdPricingIndexRouteImport } from './routes/_app/proposal-analyses/$proposalId/pricing/index'
import { Route as AppAnalysesPolicyIdPricingIndexRouteImport } from './routes/_app/analyses/$policyId/pricing/index'
import { Route as AppSettingsProductsPaymentMethodsProductCodeRouteImport } from './routes/_app/settings/products/payment-methods/$productCode'
import { Route as AppQuotesRdEquipamentosProposalIdApoliceRouteImport } from './routes/_app/quotes/rd-equipamentos/$proposalId/apolice'
import { Route as AppQuotesProductsNewIdIndexRouteImport } from './routes/_app/quotes/products/new/$id/index'
import { Route as AppProposalsIdPmeEditIndexRouteImport } from './routes/_app/proposals/$id/pme/edit/index'
import { Route as AppProposalsIdCapitalGlobalEditIndexRouteImport } from './routes/_app/proposals/$id/capital-global/edit/index'
import { Route as AppPoliciesPolicyIdInspectionsInspectionIdIndexRouteImport } from './routes/_app/policies/$policyId/inspections/$inspectionId/index'
import { Route as AppQuotesProductsNewIdPolicyIdIndexRouteImport } from './routes/_app/quotes/products/new/$id/$policyId/index'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentIndexRoute = PaymentIndexRouteImport.update({
  id: '/payment/',
  path: '/payment/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentTokenRoute = PaymentTokenRouteImport.update({
  id: '/payment/$token',
  path: '/payment/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTwoFactorRoute = AuthTwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTermsRoute = AuthTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetRoute = AuthResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotRoute = AuthForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => AuthRoute,
} as any)
const AuthExpiredLinkRoute = AuthExpiredLinkRouteImport.update({
  id: '/expired-link',
  path: '/expired-link',
  getParentRoute: () => AuthRoute,
} as any)
const AppSupportRoute = AppSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersRoute = AppBrokersRouteImport.update({
  id: '/brokers',
  path: '/brokers',
  getParentRoute: () => AppRoute,
} as any)
const AppAdvisoriesRoute = AppAdvisoriesRouteImport.update({
  id: '/advisories',
  path: '/advisories',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIndexRoute = AppQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalsIndexRoute = AppProposalsIndexRouteImport.update({
  id: '/proposals/',
  path: '/proposals/',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalAnalysesIndexRoute =
  AppProposalAnalysesIndexRouteImport.update({
    id: '/proposal-analyses/',
    path: '/proposal-analyses/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPoliciesIndexRoute = AppPoliciesIndexRouteImport.update({
  id: '/policies/',
  path: '/policies/',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsIndexRoute = AppNotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationsIndexRoute = AppIntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => AppRoute,
} as any)
const AppInspectionsIndexRoute = AppInspectionsIndexRouteImport.update({
  id: '/inspections/',
  path: '/inspections/',
  getParentRoute: () => AppRoute,
} as any)
const AppFinancialIndexRoute = AppFinancialIndexRouteImport.update({
  id: '/financial/',
  path: '/financial/',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersIndexRoute = AppBrokersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBrokersRoute,
} as any)
const AppAnalysesIndexRoute = AppAnalysesIndexRouteImport.update({
  id: '/analyses/',
  path: '/analyses/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdvisoriesIndexRoute = AppAdvisoriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdvisoriesRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsReportsRoute = AppSettingsReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAuditRoute = AppSettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsProductsIndexRoute =
  AppSettingsProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppQuotesRdEquipamentosIndexRoute =
  AppQuotesRdEquipamentosIndexRouteImport.update({
    id: '/quotes/rd-equipamentos/',
    path: '/quotes/rd-equipamentos/',
    getParentRoute: () => AppRoute,
  } as any)
const AppQuotesProductsIndexRoute = AppQuotesProductsIndexRouteImport.update({
  id: '/quotes/products/',
  path: '/quotes/products/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesPolicyIdIndexRoute = AppQuotesPolicyIdIndexRouteImport.update({
  id: '/quotes/$policyId/',
  path: '/quotes/$policyId/',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalsIdIndexRoute = AppProposalsIdIndexRouteImport.update({
  id: '/proposals/$id/',
  path: '/proposals/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalAnalysesProposalIdIndexRoute =
  AppProposalAnalysesProposalIdIndexRouteImport.update({
    id: '/proposal-analyses/$proposalId/',
    path: '/proposal-analyses/$proposalId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPoliciesPolicyIdIndexRoute =
  AppPoliciesPolicyIdIndexRouteImport.update({
    id: '/policies/$policyId/',
    path: '/policies/$policyId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppIntegrationsPolicyIdIndexRoute =
  AppIntegrationsPolicyIdIndexRouteImport.update({
    id: '/integrations/$policyId/',
    path: '/integrations/$policyId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppBrokersIdIndexRoute = AppBrokersIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => AppBrokersRoute,
} as any)
const AppAnalysesPolicyIdIndexRoute =
  AppAnalysesPolicyIdIndexRouteImport.update({
    id: '/analyses/$policyId/',
    path: '/analyses/$policyId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdvisoriesIdIndexRoute = AppAdvisoriesIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => AppAdvisoriesRoute,
} as any)
const AppQuotesProductsNewRoute = AppQuotesProductsNewRouteImport.update({
  id: '/quotes/products/new',
  path: '/quotes/products/new',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesPolicyIdEditRoute = AppQuotesPolicyIdEditRouteImport.update({
  id: '/quotes/$policyId/edit',
  path: '/quotes/$policyId/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsProductsPaymentMethodsIndexRoute =
  AppSettingsProductsPaymentMethodsIndexRouteImport.update({
    id: '/products/payment-methods/',
    path: '/products/payment-methods/',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppQuotesProductsNewIndexRoute =
  AppQuotesProductsNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppQuotesProductsNewRoute,
  } as any)
const AppProposalsIdPmeIndexRoute = AppProposalsIdPmeIndexRouteImport.update({
  id: '/proposals/$id/pme/',
  path: '/proposals/$id/pme/',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalsIdEditIndexRoute = AppProposalsIdEditIndexRouteImport.update({
  id: '/proposals/$id/edit/',
  path: '/proposals/$id/edit/',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalsIdCapitalGlobalIndexRoute =
  AppProposalsIdCapitalGlobalIndexRouteImport.update({
    id: '/proposals/$id/capital-global/',
    path: '/proposals/$id/capital-global/',
    getParentRoute: () => AppRoute,
  } as any)
const AppProposalAnalysesProposalIdPricingIndexRoute =
  AppProposalAnalysesProposalIdPricingIndexRouteImport.update({
    id: '/proposal-analyses/$proposalId/pricing/',
    path: '/proposal-analyses/$proposalId/pricing/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAnalysesPolicyIdPricingIndexRoute =
  AppAnalysesPolicyIdPricingIndexRouteImport.update({
    id: '/analyses/$policyId/pricing/',
    path: '/analyses/$policyId/pricing/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsProductsPaymentMethodsProductCodeRoute =
  AppSettingsProductsPaymentMethodsProductCodeRouteImport.update({
    id: '/products/payment-methods/$productCode',
    path: '/products/payment-methods/$productCode',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppQuotesRdEquipamentosProposalIdApoliceRoute =
  AppQuotesRdEquipamentosProposalIdApoliceRouteImport.update({
    id: '/quotes/rd-equipamentos/$proposalId/apolice',
    path: '/quotes/rd-equipamentos/$proposalId/apolice',
    getParentRoute: () => AppRoute,
  } as any)
const AppQuotesProductsNewIdIndexRoute =
  AppQuotesProductsNewIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AppQuotesProductsNewRoute,
  } as any)
const AppProposalsIdPmeEditIndexRoute =
  AppProposalsIdPmeEditIndexRouteImport.update({
    id: '/proposals/$id/pme/edit/',
    path: '/proposals/$id/pme/edit/',
    getParentRoute: () => AppRoute,
  } as any)
const AppProposalsIdCapitalGlobalEditIndexRoute =
  AppProposalsIdCapitalGlobalEditIndexRouteImport.update({
    id: '/proposals/$id/capital-global/edit/',
    path: '/proposals/$id/capital-global/edit/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPoliciesPolicyIdInspectionsInspectionIdIndexRoute =
  AppPoliciesPolicyIdInspectionsInspectionIdIndexRouteImport.update({
    id: '/policies/$policyId/inspections/$inspectionId/',
    path: '/policies/$policyId/inspections/$inspectionId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppQuotesProductsNewIdPolicyIdIndexRoute =
  AppQuotesProductsNewIdPolicyIdIndexRouteImport.update({
    id: '/$id/$policyId/',
    path: '/$id/$policyId/',
    getParentRoute: () => AppQuotesProductsNewRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/advisories': typeof AppAdvisoriesRouteWithChildren
  '/brokers': typeof AppBrokersRouteWithChildren
  '/dashboard': typeof AppDashboardRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/support': typeof AppSupportRoute
  '/expired-link': typeof AuthExpiredLinkRoute
  '/forgot': typeof AuthForgotRoute
  '/login': typeof AuthLoginRoute
  '/reset': typeof AuthResetRoute
  '/terms': typeof AuthTermsRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/payment/$token': typeof PaymentTokenRoute
  '/payment/': typeof PaymentIndexRoute
  '/settings/audit': typeof AppSettingsAuditRoute
  '/settings/reports': typeof AppSettingsReportsRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/advisories/': typeof AppAdvisoriesIndexRoute
  '/analyses/': typeof AppAnalysesIndexRoute
  '/brokers/': typeof AppBrokersIndexRoute
  '/financial/': typeof AppFinancialIndexRoute
  '/inspections/': typeof AppInspectionsIndexRoute
  '/integrations/': typeof AppIntegrationsIndexRoute
  '/notifications/': typeof AppNotificationsIndexRoute
  '/policies/': typeof AppPoliciesIndexRoute
  '/proposal-analyses/': typeof AppProposalAnalysesIndexRoute
  '/proposals/': typeof AppProposalsIndexRoute
  '/quotes/': typeof AppQuotesIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/quotes/$policyId/edit': typeof AppQuotesPolicyIdEditRoute
  '/quotes/products/new': typeof AppQuotesProductsNewRouteWithChildren
  '/advisories/$id/': typeof AppAdvisoriesIdIndexRoute
  '/analyses/$policyId/': typeof AppAnalysesPolicyIdIndexRoute
  '/brokers/$id/': typeof AppBrokersIdIndexRoute
  '/integrations/$policyId/': typeof AppIntegrationsPolicyIdIndexRoute
  '/policies/$policyId/': typeof AppPoliciesPolicyIdIndexRoute
  '/proposal-analyses/$proposalId/': typeof AppProposalAnalysesProposalIdIndexRoute
  '/proposals/$id/': typeof AppProposalsIdIndexRoute
  '/quotes/$policyId/': typeof AppQuotesPolicyIdIndexRoute
  '/quotes/products/': typeof AppQuotesProductsIndexRoute
  '/quotes/rd-equipamentos/': typeof AppQuotesRdEquipamentosIndexRoute
  '/settings/products/': typeof AppSettingsProductsIndexRoute
  '/quotes/rd-equipamentos/$proposalId/apolice': typeof AppQuotesRdEquipamentosProposalIdApoliceRoute
  '/settings/products/payment-methods/$productCode': typeof AppSettingsProductsPaymentMethodsProductCodeRoute
  '/analyses/$policyId/pricing/': typeof AppAnalysesPolicyIdPricingIndexRoute
  '/proposal-analyses/$proposalId/pricing/': typeof AppProposalAnalysesProposalIdPricingIndexRoute
  '/proposals/$id/capital-global/': typeof AppProposalsIdCapitalGlobalIndexRoute
  '/proposals/$id/edit/': typeof AppProposalsIdEditIndexRoute
  '/proposals/$id/pme/': typeof AppProposalsIdPmeIndexRoute
  '/quotes/products/new/': typeof AppQuotesProductsNewIndexRoute
  '/settings/products/payment-methods/': typeof AppSettingsProductsPaymentMethodsIndexRoute
  '/policies/$policyId/inspections/$inspectionId/': typeof AppPoliciesPolicyIdInspectionsInspectionIdIndexRoute
  '/proposals/$id/capital-global/edit/': typeof AppProposalsIdCapitalGlobalEditIndexRoute
  '/proposals/$id/pme/edit/': typeof AppProposalsIdPmeEditIndexRoute
  '/quotes/products/new/$id/': typeof AppQuotesProductsNewIdIndexRoute
  '/quotes/products/new/$id/$policyId/': typeof AppQuotesProductsNewIdPolicyIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AppDashboardRoute
  '/support': typeof AppSupportRoute
  '/expired-link': typeof AuthExpiredLinkRoute
  '/forgot': typeof AuthForgotRoute
  '/login': typeof AuthLoginRoute
  '/reset': typeof AuthResetRoute
  '/terms': typeof AuthTermsRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/payment/$token': typeof PaymentTokenRoute
  '/payment': typeof PaymentIndexRoute
  '/settings/audit': typeof AppSettingsAuditRoute
  '/settings/reports': typeof AppSettingsReportsRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/advisories': typeof AppAdvisoriesIndexRoute
  '/analyses': typeof AppAnalysesIndexRoute
  '/brokers': typeof AppBrokersIndexRoute
  '/financial': typeof AppFinancialIndexRoute
  '/inspections': typeof AppInspectionsIndexRoute
  '/integrations': typeof AppIntegrationsIndexRoute
  '/notifications': typeof AppNotificationsIndexRoute
  '/policies': typeof AppPoliciesIndexRoute
  '/proposal-analyses': typeof AppProposalAnalysesIndexRoute
  '/proposals': typeof AppProposalsIndexRoute
  '/quotes': typeof AppQuotesIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/quotes/$policyId/edit': typeof AppQuotesPolicyIdEditRoute
  '/advisories/$id': typeof AppAdvisoriesIdIndexRoute
  '/analyses/$policyId': typeof AppAnalysesPolicyIdIndexRoute
  '/brokers/$id': typeof AppBrokersIdIndexRoute
  '/integrations/$policyId': typeof AppIntegrationsPolicyIdIndexRoute
  '/policies/$policyId': typeof AppPoliciesPolicyIdIndexRoute
  '/proposal-analyses/$proposalId': typeof AppProposalAnalysesProposalIdIndexRoute
  '/proposals/$id': typeof AppProposalsIdIndexRoute
  '/quotes/$policyId': typeof AppQuotesPolicyIdIndexRoute
  '/quotes/products': typeof AppQuotesProductsIndexRoute
  '/quotes/rd-equipamentos': typeof AppQuotesRdEquipamentosIndexRoute
  '/settings/products': typeof AppSettingsProductsIndexRoute
  '/quotes/rd-equipamentos/$proposalId/apolice': typeof AppQuotesRdEquipamentosProposalIdApoliceRoute
  '/settings/products/payment-methods/$productCode': typeof AppSettingsProductsPaymentMethodsProductCodeRoute
  '/analyses/$policyId/pricing': typeof AppAnalysesPolicyIdPricingIndexRoute
  '/proposal-analyses/$proposalId/pricing': typeof AppProposalAnalysesProposalIdPricingIndexRoute
  '/proposals/$id/capital-global': typeof AppProposalsIdCapitalGlobalIndexRoute
  '/proposals/$id/edit': typeof AppProposalsIdEditIndexRoute
  '/proposals/$id/pme': typeof AppProposalsIdPmeIndexRoute
  '/quotes/products/new': typeof AppQuotesProductsNewIndexRoute
  '/settings/products/payment-methods': typeof AppSettingsProductsPaymentMethodsIndexRoute
  '/policies/$policyId/inspections/$inspectionId': typeof AppPoliciesPolicyIdInspectionsInspectionIdIndexRoute
  '/proposals/$id/capital-global/edit': typeof AppProposalsIdCapitalGlobalEditIndexRoute
  '/proposals/$id/pme/edit': typeof AppProposalsIdPmeEditIndexRoute
  '/quotes/products/new/$id': typeof AppQuotesProductsNewIdIndexRoute
  '/quotes/products/new/$id/$policyId': typeof AppQuotesProductsNewIdPolicyIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/advisories': typeof AppAdvisoriesRouteWithChildren
  '/_app/brokers': typeof AppBrokersRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/support': typeof AppSupportRoute
  '/_auth/expired-link': typeof AuthExpiredLinkRoute
  '/_auth/forgot': typeof AuthForgotRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset': typeof AuthResetRoute
  '/_auth/terms': typeof AuthTermsRoute
  '/_auth/two-factor': typeof AuthTwoFactorRoute
  '/payment/$token': typeof PaymentTokenRoute
  '/payment/': typeof PaymentIndexRoute
  '/_app/settings/audit': typeof AppSettingsAuditRoute
  '/_app/settings/reports': typeof AppSettingsReportsRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/advisories/': typeof AppAdvisoriesIndexRoute
  '/_app/analyses/': typeof AppAnalysesIndexRoute
  '/_app/brokers/': typeof AppBrokersIndexRoute
  '/_app/financial/': typeof AppFinancialIndexRoute
  '/_app/inspections/': typeof AppInspectionsIndexRoute
  '/_app/integrations/': typeof AppIntegrationsIndexRoute
  '/_app/notifications/': typeof AppNotificationsIndexRoute
  '/_app/policies/': typeof AppPoliciesIndexRoute
  '/_app/proposal-analyses/': typeof AppProposalAnalysesIndexRoute
  '/_app/proposals/': typeof AppProposalsIndexRoute
  '/_app/quotes/': typeof AppQuotesIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/quotes/$policyId/edit': typeof AppQuotesPolicyIdEditRoute
  '/_app/quotes/products/new': typeof AppQuotesProductsNewRouteWithChildren
  '/_app/advisories/$id/': typeof AppAdvisoriesIdIndexRoute
  '/_app/analyses/$policyId/': typeof AppAnalysesPolicyIdIndexRoute
  '/_app/brokers/$id/': typeof AppBrokersIdIndexRoute
  '/_app/integrations/$policyId/': typeof AppIntegrationsPolicyIdIndexRoute
  '/_app/policies/$policyId/': typeof AppPoliciesPolicyIdIndexRoute
  '/_app/proposal-analyses/$proposalId/': typeof AppProposalAnalysesProposalIdIndexRoute
  '/_app/proposals/$id/': typeof AppProposalsIdIndexRoute
  '/_app/quotes/$policyId/': typeof AppQuotesPolicyIdIndexRoute
  '/_app/quotes/products/': typeof AppQuotesProductsIndexRoute
  '/_app/quotes/rd-equipamentos/': typeof AppQuotesRdEquipamentosIndexRoute
  '/_app/settings/products/': typeof AppSettingsProductsIndexRoute
  '/_app/quotes/rd-equipamentos/$proposalId/apolice': typeof AppQuotesRdEquipamentosProposalIdApoliceRoute
  '/_app/settings/products/payment-methods/$productCode': typeof AppSettingsProductsPaymentMethodsProductCodeRoute
  '/_app/analyses/$policyId/pricing/': typeof AppAnalysesPolicyIdPricingIndexRoute
  '/_app/proposal-analyses/$proposalId/pricing/': typeof AppProposalAnalysesProposalIdPricingIndexRoute
  '/_app/proposals/$id/capital-global/': typeof AppProposalsIdCapitalGlobalIndexRoute
  '/_app/proposals/$id/edit/': typeof AppProposalsIdEditIndexRoute
  '/_app/proposals/$id/pme/': typeof AppProposalsIdPmeIndexRoute
  '/_app/quotes/products/new/': typeof AppQuotesProductsNewIndexRoute
  '/_app/settings/products/payment-methods/': typeof AppSettingsProductsPaymentMethodsIndexRoute
  '/_app/policies/$policyId/inspections/$inspectionId/': typeof AppPoliciesPolicyIdInspectionsInspectionIdIndexRoute
  '/_app/proposals/$id/capital-global/edit/': typeof AppProposalsIdCapitalGlobalEditIndexRoute
  '/_app/proposals/$id/pme/edit/': typeof AppProposalsIdPmeEditIndexRoute
  '/_app/quotes/products/new/$id/': typeof AppQuotesProductsNewIdIndexRoute
  '/_app/quotes/products/new/$id/$policyId/': typeof AppQuotesProductsNewIdPolicyIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/advisories'
    | '/brokers'
    | '/dashboard'
    | '/settings'
    | '/support'
    | '/expired-link'
    | '/forgot'
    | '/login'
    | '/reset'
    | '/terms'
    | '/two-factor'
    | '/payment/$token'
    | '/payment/'
    | '/settings/audit'
    | '/settings/reports'
    | '/settings/users'
    | '/advisories/'
    | '/analyses/'
    | '/brokers/'
    | '/financial/'
    | '/inspections/'
    | '/integrations/'
    | '/notifications/'
    | '/policies/'
    | '/proposal-analyses/'
    | '/proposals/'
    | '/quotes/'
    | '/reports/'
    | '/settings/'
    | '/quotes/$policyId/edit'
    | '/quotes/products/new'
    | '/advisories/$id/'
    | '/analyses/$policyId/'
    | '/brokers/$id/'
    | '/integrations/$policyId/'
    | '/policies/$policyId/'
    | '/proposal-analyses/$proposalId/'
    | '/proposals/$id/'
    | '/quotes/$policyId/'
    | '/quotes/products/'
    | '/quotes/rd-equipamentos/'
    | '/settings/products/'
    | '/quotes/rd-equipamentos/$proposalId/apolice'
    | '/settings/products/payment-methods/$productCode'
    | '/analyses/$policyId/pricing/'
    | '/proposal-analyses/$proposalId/pricing/'
    | '/proposals/$id/capital-global/'
    | '/proposals/$id/edit/'
    | '/proposals/$id/pme/'
    | '/quotes/products/new/'
    | '/settings/products/payment-methods/'
    | '/policies/$policyId/inspections/$inspectionId/'
    | '/proposals/$id/capital-global/edit/'
    | '/proposals/$id/pme/edit/'
    | '/quotes/products/new/$id/'
    | '/quotes/products/new/$id/$policyId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/support'
    | '/expired-link'
    | '/forgot'
    | '/login'
    | '/reset'
    | '/terms'
    | '/two-factor'
    | '/payment/$token'
    | '/payment'
    | '/settings/audit'
    | '/settings/reports'
    | '/settings/users'
    | '/advisories'
    | '/analyses'
    | '/brokers'
    | '/financial'
    | '/inspections'
    | '/integrations'
    | '/notifications'
    | '/policies'
    | '/proposal-analyses'
    | '/proposals'
    | '/quotes'
    | '/reports'
    | '/settings'
    | '/quotes/$policyId/edit'
    | '/advisories/$id'
    | '/analyses/$policyId'
    | '/brokers/$id'
    | '/integrations/$policyId'
    | '/policies/$policyId'
    | '/proposal-analyses/$proposalId'
    | '/proposals/$id'
    | '/quotes/$policyId'
    | '/quotes/products'
    | '/quotes/rd-equipamentos'
    | '/settings/products'
    | '/quotes/rd-equipamentos/$proposalId/apolice'
    | '/settings/products/payment-methods/$productCode'
    | '/analyses/$policyId/pricing'
    | '/proposal-analyses/$proposalId/pricing'
    | '/proposals/$id/capital-global'
    | '/proposals/$id/edit'
    | '/proposals/$id/pme'
    | '/quotes/products/new'
    | '/settings/products/payment-methods'
    | '/policies/$policyId/inspections/$inspectionId'
    | '/proposals/$id/capital-global/edit'
    | '/proposals/$id/pme/edit'
    | '/quotes/products/new/$id'
    | '/quotes/products/new/$id/$policyId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_app/advisories'
    | '/_app/brokers'
    | '/_app/dashboard'
    | '/_app/settings'
    | '/_app/support'
    | '/_auth/expired-link'
    | '/_auth/forgot'
    | '/_auth/login'
    | '/_auth/reset'
    | '/_auth/terms'
    | '/_auth/two-factor'
    | '/payment/$token'
    | '/payment/'
    | '/_app/settings/audit'
    | '/_app/settings/reports'
    | '/_app/settings/users'
    | '/_app/advisories/'
    | '/_app/analyses/'
    | '/_app/brokers/'
    | '/_app/financial/'
    | '/_app/inspections/'
    | '/_app/integrations/'
    | '/_app/notifications/'
    | '/_app/policies/'
    | '/_app/proposal-analyses/'
    | '/_app/proposals/'
    | '/_app/quotes/'
    | '/_app/reports/'
    | '/_app/settings/'
    | '/_app/quotes/$policyId/edit'
    | '/_app/quotes/products/new'
    | '/_app/advisories/$id/'
    | '/_app/analyses/$policyId/'
    | '/_app/brokers/$id/'
    | '/_app/integrations/$policyId/'
    | '/_app/policies/$policyId/'
    | '/_app/proposal-analyses/$proposalId/'
    | '/_app/proposals/$id/'
    | '/_app/quotes/$policyId/'
    | '/_app/quotes/products/'
    | '/_app/quotes/rd-equipamentos/'
    | '/_app/settings/products/'
    | '/_app/quotes/rd-equipamentos/$proposalId/apolice'
    | '/_app/settings/products/payment-methods/$productCode'
    | '/_app/analyses/$policyId/pricing/'
    | '/_app/proposal-analyses/$proposalId/pricing/'
    | '/_app/proposals/$id/capital-global/'
    | '/_app/proposals/$id/edit/'
    | '/_app/proposals/$id/pme/'
    | '/_app/quotes/products/new/'
    | '/_app/settings/products/payment-methods/'
    | '/_app/policies/$policyId/inspections/$inspectionId/'
    | '/_app/proposals/$id/capital-global/edit/'
    | '/_app/proposals/$id/pme/edit/'
    | '/_app/quotes/products/new/$id/'
    | '/_app/quotes/products/new/$id/$policyId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  PaymentTokenRoute: typeof PaymentTokenRoute
  PaymentIndexRoute: typeof PaymentIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/': {
      id: '/payment/'
      path: '/payment'
      fullPath: '/payment/'
      preLoaderRoute: typeof PaymentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/$token': {
      id: '/payment/$token'
      path: '/payment/$token'
      fullPath: '/payment/$token'
      preLoaderRoute: typeof PaymentTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/two-factor': {
      id: '/_auth/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof AuthTwoFactorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/terms': {
      id: '/_auth/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof AuthTermsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset': {
      id: '/_auth/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof AuthResetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot': {
      id: '/_auth/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof AuthForgotRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/expired-link': {
      id: '/_auth/expired-link'
      path: '/expired-link'
      fullPath: '/expired-link'
      preLoaderRoute: typeof AuthExpiredLinkRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/support': {
      id: '/_app/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AppSupportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers': {
      id: '/_app/brokers'
      path: '/brokers'
      fullPath: '/brokers'
      preLoaderRoute: typeof AppBrokersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/advisories': {
      id: '/_app/advisories'
      path: '/advisories'
      fullPath: '/advisories'
      preLoaderRoute: typeof AppAdvisoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/': {
      id: '/_app/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AppQuotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/': {
      id: '/_app/proposals/'
      path: '/proposals'
      fullPath: '/proposals/'
      preLoaderRoute: typeof AppProposalsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposal-analyses/': {
      id: '/_app/proposal-analyses/'
      path: '/proposal-analyses'
      fullPath: '/proposal-analyses/'
      preLoaderRoute: typeof AppProposalAnalysesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/policies/': {
      id: '/_app/policies/'
      path: '/policies'
      fullPath: '/policies/'
      preLoaderRoute: typeof AppPoliciesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications/': {
      id: '/_app/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AppNotificationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations/': {
      id: '/_app/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof AppIntegrationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inspections/': {
      id: '/_app/inspections/'
      path: '/inspections'
      fullPath: '/inspections/'
      preLoaderRoute: typeof AppInspectionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/financial/': {
      id: '/_app/financial/'
      path: '/financial'
      fullPath: '/financial/'
      preLoaderRoute: typeof AppFinancialIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/': {
      id: '/_app/brokers/'
      path: '/'
      fullPath: '/brokers/'
      preLoaderRoute: typeof AppBrokersIndexRouteImport
      parentRoute: typeof AppBrokersRoute
    }
    '/_app/analyses/': {
      id: '/_app/analyses/'
      path: '/analyses'
      fullPath: '/analyses/'
      preLoaderRoute: typeof AppAnalysesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/advisories/': {
      id: '/_app/advisories/'
      path: '/'
      fullPath: '/advisories/'
      preLoaderRoute: typeof AppAdvisoriesIndexRouteImport
      parentRoute: typeof AppAdvisoriesRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/reports': {
      id: '/_app/settings/reports'
      path: '/reports'
      fullPath: '/settings/reports'
      preLoaderRoute: typeof AppSettingsReportsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/audit': {
      id: '/_app/settings/audit'
      path: '/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof AppSettingsAuditRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/products/': {
      id: '/_app/settings/products/'
      path: '/products'
      fullPath: '/settings/products/'
      preLoaderRoute: typeof AppSettingsProductsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/quotes/rd-equipamentos/': {
      id: '/_app/quotes/rd-equipamentos/'
      path: '/quotes/rd-equipamentos'
      fullPath: '/quotes/rd-equipamentos/'
      preLoaderRoute: typeof AppQuotesRdEquipamentosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/products/': {
      id: '/_app/quotes/products/'
      path: '/quotes/products'
      fullPath: '/quotes/products/'
      preLoaderRoute: typeof AppQuotesProductsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/$policyId/': {
      id: '/_app/quotes/$policyId/'
      path: '/quotes/$policyId'
      fullPath: '/quotes/$policyId/'
      preLoaderRoute: typeof AppQuotesPolicyIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/$id/': {
      id: '/_app/proposals/$id/'
      path: '/proposals/$id'
      fullPath: '/proposals/$id/'
      preLoaderRoute: typeof AppProposalsIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposal-analyses/$proposalId/': {
      id: '/_app/proposal-analyses/$proposalId/'
      path: '/proposal-analyses/$proposalId'
      fullPath: '/proposal-analyses/$proposalId/'
      preLoaderRoute: typeof AppProposalAnalysesProposalIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/policies/$policyId/': {
      id: '/_app/policies/$policyId/'
      path: '/policies/$policyId'
      fullPath: '/policies/$policyId/'
      preLoaderRoute: typeof AppPoliciesPolicyIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations/$policyId/': {
      id: '/_app/integrations/$policyId/'
      path: '/integrations/$policyId'
      fullPath: '/integrations/$policyId/'
      preLoaderRoute: typeof AppIntegrationsPolicyIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/$id/': {
      id: '/_app/brokers/$id/'
      path: '/$id'
      fullPath: '/brokers/$id/'
      preLoaderRoute: typeof AppBrokersIdIndexRouteImport
      parentRoute: typeof AppBrokersRoute
    }
    '/_app/analyses/$policyId/': {
      id: '/_app/analyses/$policyId/'
      path: '/analyses/$policyId'
      fullPath: '/analyses/$policyId/'
      preLoaderRoute: typeof AppAnalysesPolicyIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/advisories/$id/': {
      id: '/_app/advisories/$id/'
      path: '/$id'
      fullPath: '/advisories/$id/'
      preLoaderRoute: typeof AppAdvisoriesIdIndexRouteImport
      parentRoute: typeof AppAdvisoriesRoute
    }
    '/_app/quotes/products/new': {
      id: '/_app/quotes/products/new'
      path: '/quotes/products/new'
      fullPath: '/quotes/products/new'
      preLoaderRoute: typeof AppQuotesProductsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/$policyId/edit': {
      id: '/_app/quotes/$policyId/edit'
      path: '/quotes/$policyId/edit'
      fullPath: '/quotes/$policyId/edit'
      preLoaderRoute: typeof AppQuotesPolicyIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/products/payment-methods/': {
      id: '/_app/settings/products/payment-methods/'
      path: '/products/payment-methods'
      fullPath: '/settings/products/payment-methods/'
      preLoaderRoute: typeof AppSettingsProductsPaymentMethodsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/quotes/products/new/': {
      id: '/_app/quotes/products/new/'
      path: '/'
      fullPath: '/quotes/products/new/'
      preLoaderRoute: typeof AppQuotesProductsNewIndexRouteImport
      parentRoute: typeof AppQuotesProductsNewRoute
    }
    '/_app/proposals/$id/pme/': {
      id: '/_app/proposals/$id/pme/'
      path: '/proposals/$id/pme'
      fullPath: '/proposals/$id/pme/'
      preLoaderRoute: typeof AppProposalsIdPmeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/$id/edit/': {
      id: '/_app/proposals/$id/edit/'
      path: '/proposals/$id/edit'
      fullPath: '/proposals/$id/edit/'
      preLoaderRoute: typeof AppProposalsIdEditIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/$id/capital-global/': {
      id: '/_app/proposals/$id/capital-global/'
      path: '/proposals/$id/capital-global'
      fullPath: '/proposals/$id/capital-global/'
      preLoaderRoute: typeof AppProposalsIdCapitalGlobalIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposal-analyses/$proposalId/pricing/': {
      id: '/_app/proposal-analyses/$proposalId/pricing/'
      path: '/proposal-analyses/$proposalId/pricing'
      fullPath: '/proposal-analyses/$proposalId/pricing/'
      preLoaderRoute: typeof AppProposalAnalysesProposalIdPricingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analyses/$policyId/pricing/': {
      id: '/_app/analyses/$policyId/pricing/'
      path: '/analyses/$policyId/pricing'
      fullPath: '/analyses/$policyId/pricing/'
      preLoaderRoute: typeof AppAnalysesPolicyIdPricingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/products/payment-methods/$productCode': {
      id: '/_app/settings/products/payment-methods/$productCode'
      path: '/products/payment-methods/$productCode'
      fullPath: '/settings/products/payment-methods/$productCode'
      preLoaderRoute: typeof AppSettingsProductsPaymentMethodsProductCodeRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/quotes/rd-equipamentos/$proposalId/apolice': {
      id: '/_app/quotes/rd-equipamentos/$proposalId/apolice'
      path: '/quotes/rd-equipamentos/$proposalId/apolice'
      fullPath: '/quotes/rd-equipamentos/$proposalId/apolice'
      preLoaderRoute: typeof AppQuotesRdEquipamentosProposalIdApoliceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/products/new/$id/': {
      id: '/_app/quotes/products/new/$id/'
      path: '/$id'
      fullPath: '/quotes/products/new/$id/'
      preLoaderRoute: typeof AppQuotesProductsNewIdIndexRouteImport
      parentRoute: typeof AppQuotesProductsNewRoute
    }
    '/_app/proposals/$id/pme/edit/': {
      id: '/_app/proposals/$id/pme/edit/'
      path: '/proposals/$id/pme/edit'
      fullPath: '/proposals/$id/pme/edit/'
      preLoaderRoute: typeof AppProposalsIdPmeEditIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/$id/capital-global/edit/': {
      id: '/_app/proposals/$id/capital-global/edit/'
      path: '/proposals/$id/capital-global/edit'
      fullPath: '/proposals/$id/capital-global/edit/'
      preLoaderRoute: typeof AppProposalsIdCapitalGlobalEditIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/policies/$policyId/inspections/$inspectionId/': {
      id: '/_app/policies/$policyId/inspections/$inspectionId/'
      path: '/policies/$policyId/inspections/$inspectionId'
      fullPath: '/policies/$policyId/inspections/$inspectionId/'
      preLoaderRoute: typeof AppPoliciesPolicyIdInspectionsInspectionIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/products/new/$id/$policyId/': {
      id: '/_app/quotes/products/new/$id/$policyId/'
      path: '/$id/$policyId'
      fullPath: '/quotes/products/new/$id/$policyId/'
      preLoaderRoute: typeof AppQuotesProductsNewIdPolicyIdIndexRouteImport
      parentRoute: typeof AppQuotesProductsNewRoute
    }
  }
}

interface AppAdvisoriesRouteChildren {
  AppAdvisoriesIndexRoute: typeof AppAdvisoriesIndexRoute
  AppAdvisoriesIdIndexRoute: typeof AppAdvisoriesIdIndexRoute
}

const AppAdvisoriesRouteChildren: AppAdvisoriesRouteChildren = {
  AppAdvisoriesIndexRoute: AppAdvisoriesIndexRoute,
  AppAdvisoriesIdIndexRoute: AppAdvisoriesIdIndexRoute,
}

const AppAdvisoriesRouteWithChildren = AppAdvisoriesRoute._addFileChildren(
  AppAdvisoriesRouteChildren,
)

interface AppBrokersRouteChildren {
  AppBrokersIndexRoute: typeof AppBrokersIndexRoute
  AppBrokersIdIndexRoute: typeof AppBrokersIdIndexRoute
}

const AppBrokersRouteChildren: AppBrokersRouteChildren = {
  AppBrokersIndexRoute: AppBrokersIndexRoute,
  AppBrokersIdIndexRoute: AppBrokersIdIndexRoute,
}

const AppBrokersRouteWithChildren = AppBrokersRoute._addFileChildren(
  AppBrokersRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsAuditRoute: typeof AppSettingsAuditRoute
  AppSettingsReportsRoute: typeof AppSettingsReportsRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsProductsIndexRoute: typeof AppSettingsProductsIndexRoute
  AppSettingsProductsPaymentMethodsProductCodeRoute: typeof AppSettingsProductsPaymentMethodsProductCodeRoute
  AppSettingsProductsPaymentMethodsIndexRoute: typeof AppSettingsProductsPaymentMethodsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAuditRoute: AppSettingsAuditRoute,
  AppSettingsReportsRoute: AppSettingsReportsRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsProductsIndexRoute: AppSettingsProductsIndexRoute,
  AppSettingsProductsPaymentMethodsProductCodeRoute:
    AppSettingsProductsPaymentMethodsProductCodeRoute,
  AppSettingsProductsPaymentMethodsIndexRoute:
    AppSettingsProductsPaymentMethodsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppQuotesProductsNewRouteChildren {
  AppQuotesProductsNewIndexRoute: typeof AppQuotesProductsNewIndexRoute
  AppQuotesProductsNewIdIndexRoute: typeof AppQuotesProductsNewIdIndexRoute
  AppQuotesProductsNewIdPolicyIdIndexRoute: typeof AppQuotesProductsNewIdPolicyIdIndexRoute
}

const AppQuotesProductsNewRouteChildren: AppQuotesProductsNewRouteChildren = {
  AppQuotesProductsNewIndexRoute: AppQuotesProductsNewIndexRoute,
  AppQuotesProductsNewIdIndexRoute: AppQuotesProductsNewIdIndexRoute,
  AppQuotesProductsNewIdPolicyIdIndexRoute:
    AppQuotesProductsNewIdPolicyIdIndexRoute,
}

const AppQuotesProductsNewRouteWithChildren =
  AppQuotesProductsNewRoute._addFileChildren(AppQuotesProductsNewRouteChildren)

interface AppRouteChildren {
  AppAdvisoriesRoute: typeof AppAdvisoriesRouteWithChildren
  AppBrokersRoute: typeof AppBrokersRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppSupportRoute: typeof AppSupportRoute
  AppAnalysesIndexRoute: typeof AppAnalysesIndexRoute
  AppFinancialIndexRoute: typeof AppFinancialIndexRoute
  AppInspectionsIndexRoute: typeof AppInspectionsIndexRoute
  AppIntegrationsIndexRoute: typeof AppIntegrationsIndexRoute
  AppNotificationsIndexRoute: typeof AppNotificationsIndexRoute
  AppPoliciesIndexRoute: typeof AppPoliciesIndexRoute
  AppProposalAnalysesIndexRoute: typeof AppProposalAnalysesIndexRoute
  AppProposalsIndexRoute: typeof AppProposalsIndexRoute
  AppQuotesIndexRoute: typeof AppQuotesIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppQuotesPolicyIdEditRoute: typeof AppQuotesPolicyIdEditRoute
  AppQuotesProductsNewRoute: typeof AppQuotesProductsNewRouteWithChildren
  AppAnalysesPolicyIdIndexRoute: typeof AppAnalysesPolicyIdIndexRoute
  AppIntegrationsPolicyIdIndexRoute: typeof AppIntegrationsPolicyIdIndexRoute
  AppPoliciesPolicyIdIndexRoute: typeof AppPoliciesPolicyIdIndexRoute
  AppProposalAnalysesProposalIdIndexRoute: typeof AppProposalAnalysesProposalIdIndexRoute
  AppProposalsIdIndexRoute: typeof AppProposalsIdIndexRoute
  AppQuotesPolicyIdIndexRoute: typeof AppQuotesPolicyIdIndexRoute
  AppQuotesProductsIndexRoute: typeof AppQuotesProductsIndexRoute
  AppQuotesRdEquipamentosIndexRoute: typeof AppQuotesRdEquipamentosIndexRoute
  AppQuotesRdEquipamentosProposalIdApoliceRoute: typeof AppQuotesRdEquipamentosProposalIdApoliceRoute
  AppAnalysesPolicyIdPricingIndexRoute: typeof AppAnalysesPolicyIdPricingIndexRoute
  AppProposalAnalysesProposalIdPricingIndexRoute: typeof AppProposalAnalysesProposalIdPricingIndexRoute
  AppProposalsIdCapitalGlobalIndexRoute: typeof AppProposalsIdCapitalGlobalIndexRoute
  AppProposalsIdEditIndexRoute: typeof AppProposalsIdEditIndexRoute
  AppProposalsIdPmeIndexRoute: typeof AppProposalsIdPmeIndexRoute
  AppPoliciesPolicyIdInspectionsInspectionIdIndexRoute: typeof AppPoliciesPolicyIdInspectionsInspectionIdIndexRoute
  AppProposalsIdCapitalGlobalEditIndexRoute: typeof AppProposalsIdCapitalGlobalEditIndexRoute
  AppProposalsIdPmeEditIndexRoute: typeof AppProposalsIdPmeEditIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdvisoriesRoute: AppAdvisoriesRouteWithChildren,
  AppBrokersRoute: AppBrokersRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppSupportRoute: AppSupportRoute,
  AppAnalysesIndexRoute: AppAnalysesIndexRoute,
  AppFinancialIndexRoute: AppFinancialIndexRoute,
  AppInspectionsIndexRoute: AppInspectionsIndexRoute,
  AppIntegrationsIndexRoute: AppIntegrationsIndexRoute,
  AppNotificationsIndexRoute: AppNotificationsIndexRoute,
  AppPoliciesIndexRoute: AppPoliciesIndexRoute,
  AppProposalAnalysesIndexRoute: AppProposalAnalysesIndexRoute,
  AppProposalsIndexRoute: AppProposalsIndexRoute,
  AppQuotesIndexRoute: AppQuotesIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppQuotesPolicyIdEditRoute: AppQuotesPolicyIdEditRoute,
  AppQuotesProductsNewRoute: AppQuotesProductsNewRouteWithChildren,
  AppAnalysesPolicyIdIndexRoute: AppAnalysesPolicyIdIndexRoute,
  AppIntegrationsPolicyIdIndexRoute: AppIntegrationsPolicyIdIndexRoute,
  AppPoliciesPolicyIdIndexRoute: AppPoliciesPolicyIdIndexRoute,
  AppProposalAnalysesProposalIdIndexRoute:
    AppProposalAnalysesProposalIdIndexRoute,
  AppProposalsIdIndexRoute: AppProposalsIdIndexRoute,
  AppQuotesPolicyIdIndexRoute: AppQuotesPolicyIdIndexRoute,
  AppQuotesProductsIndexRoute: AppQuotesProductsIndexRoute,
  AppQuotesRdEquipamentosIndexRoute: AppQuotesRdEquipamentosIndexRoute,
  AppQuotesRdEquipamentosProposalIdApoliceRoute:
    AppQuotesRdEquipamentosProposalIdApoliceRoute,
  AppAnalysesPolicyIdPricingIndexRoute: AppAnalysesPolicyIdPricingIndexRoute,
  AppProposalAnalysesProposalIdPricingIndexRoute:
    AppProposalAnalysesProposalIdPricingIndexRoute,
  AppProposalsIdCapitalGlobalIndexRoute: AppProposalsIdCapitalGlobalIndexRoute,
  AppProposalsIdEditIndexRoute: AppProposalsIdEditIndexRoute,
  AppProposalsIdPmeIndexRoute: AppProposalsIdPmeIndexRoute,
  AppPoliciesPolicyIdInspectionsInspectionIdIndexRoute:
    AppPoliciesPolicyIdInspectionsInspectionIdIndexRoute,
  AppProposalsIdCapitalGlobalEditIndexRoute:
    AppProposalsIdCapitalGlobalEditIndexRoute,
  AppProposalsIdPmeEditIndexRoute: AppProposalsIdPmeEditIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthExpiredLinkRoute: typeof AuthExpiredLinkRoute
  AuthForgotRoute: typeof AuthForgotRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetRoute: typeof AuthResetRoute
  AuthTermsRoute: typeof AuthTermsRoute
  AuthTwoFactorRoute: typeof AuthTwoFactorRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthExpiredLinkRoute: AuthExpiredLinkRoute,
  AuthForgotRoute: AuthForgotRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetRoute: AuthResetRoute,
  AuthTermsRoute: AuthTermsRoute,
  AuthTwoFactorRoute: AuthTwoFactorRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  PaymentTokenRoute: PaymentTokenRoute,
  PaymentIndexRoute: PaymentIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
